import React from "react";
import ite from "../../../assets/images/ite.png";
import "./index.scss"; // Assurez-vous que le chemin est correct
export const ITE = () => {
  return (
    <div className="ite mt-5">
      {" "}
      <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center mb-5">
        <div className="col-12 col-md-6 mx-auto  ">
          <div className="ite-title">Qu’est-ce que l’ITE ?</div>
          <div className="ite-text mt-3">
            L’ITE consiste à poser une couche d’isolant sur la façade extérieure
            de votre bâtiment, puis à recouvrir avec un enduit ou un bardage.
          </div>
        </div>
        <div className="col-12 col-md-6 mx-auto d-flex justify-content-center align-items-center">
          <img src={ite} alt="ite" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};
